import { Box } from '@mui/material'

import { useEffect } from 'react'
import {
	getFormattedEvents,
	useControllerFirstSourceEventsApi,
	useControllerSecondSourceEventsApi
} from '~features/events'
import { LoadPageProgress } from '~sharedUI'
import { MonthEventsDisplayer } from './monthEventsDisplayer'

interface MonthSlideProps {
	date: Date
	period: { from: string; to: string }
	onLoaded?: (monthId: string) => void
	monthId: string
}

export const MonthSlide = ({ period, onLoaded, monthId }: MonthSlideProps) => {
	const { data: firstData, isLoading: isFirstLoading } = useControllerFirstSourceEventsApi(period)
	const { data: secondData, isLoading: isSecondLoading } = useControllerSecondSourceEventsApi(period)

	const isLoading = isFirstLoading || isSecondLoading
	const isReady = !isLoading && !!firstData && !!secondData

	useEffect(() => {
		if (isReady)
			onLoaded?.(monthId)
	}, [isReady, monthId, onLoaded])

	const events = firstData && secondData
		? getFormattedEvents(firstData.data.items ?? [], secondData.items)
		: []

	return (
		<>
			{isLoading
				? (
					<Box
						display={'flex'}
						flexDirection={'column'}
						justifyContent={'center'}
						height={'100%'}
						paddingX={'40px'}
					>
						<LoadPageProgress />
					</Box>
				)
				: (
					<Box paddingBottom={'32px'} height={'100%'} alignContent={'end'}>
						<MonthEventsDisplayer events={events} />
					</Box>
				)}
		</>
	)
}
